import React from 'react';
import TeamMembersPage from './TeamMembersPage';

const TeamPage = () => <TeamMembersPage mode="team" />;

export default TeamPage;
